import { FC, useEffect, useState } from 'react';
import { getInitials } from '@component/DriverChat/helpers';

type MemberAvatarProps = {
  name: string;
  image?: string;
  size?: 'xs' | 'sm' | 'md';
};

export const MemberAvatar: FC<MemberAvatarProps> = ({
  name,
  image,
  size = 'sm',
}) => {
  const [imageFailed, setImageFailed] = useState(false);
  useEffect(() => setImageFailed(false), [image]);
  const showImage = !!image && !imageFailed;

  return (
    <span className={`dc-avatar dc-avatar--${size}`} aria-hidden="true">
      {showImage ? (
        <img src={image} alt="" onError={() => setImageFailed(true)} />
      ) : (
        getInitials(name)
      )}
    </span>
  );
};
